<template>
    <div class="work">
        <home-header :isShow="true"></home-header>
        <div class="center">
            <comment-title :titleText='`参赛作品 （共${(works_num)}个作品）`' ></comment-title>
            <div class="list">
                <el-link :underline="false" @click="newest" :type="newestSelected">最新</el-link>
                <el-link :underline="false" @click="hottest" :type="hottestSelected">最热</el-link>
                <div v-if='dataEmpty'>
                  <work-list :worksList="worksData"></work-list>
                  <Pagination :listNum="works_num" :getList="getList"></Pagination>
                </div>
                <data-empty v-else></data-empty>
            </div>
        </div>
        <home-footer></home-footer>
    </div>
</template>

<script>
  // import HomeHeader from '@/components/Header';
    import HomeHeader from '@/components/homeHeader' 

  import HomeFooter from '@/components/Footer';
  import CommentTitle from '@/components/Title';
  import WorkList from './components/Lists'
  import Pagination from '@/components/Pagination'
  import DataEmpty from '@/components/Data'
  export default {
      name: 'Works',
      components:{
        HomeHeader,
        HomeFooter,
        CommentTitle,
        WorkList,
        Pagination,
        DataEmpty
      },
      data () {
        return {
          page:1,
          page_size:12,
          worksData:[],
          works_num:0,
          type:1,
          keywords:"",
          newestSelected:'success',
          hottestSelected:'',
          dataEmpty:true
        };
      },
      mounted () {
        this.getList(this.page,this.page_size)
      },
      methods: {
        getList(page,page_size){
            let id = this.$route.params.id
            var params = {
                activity_id:id,
                type:this.type,
                keywords:this.keywords,
                page:page,
                page_size:page_size,
            }
            console.log(params)
            this.$api.worksList(params).then(res=>{
              console.log(res)
              if(res.code == 200){
                 this.worksData = res.data.works_list
                 this.works_num = res.data.works_num
                 if(res.data.works_list == ''){
                    this.dataEmpty = false
                  }else{
                    this.dataEmpty = true
                  }
              }
            }).catch(err => console.log(err))
          },

          newest(){
            this.type = 1
            this.newestSelected = "success"
            this.hottestSelected = ""
            this.getList(this.page,this.page_size)
          },
          hottest(){
            this.type = 2
            this.newestSelected = ""
            this.hottestSelected = "success"
            this.getList(this.page,this.page_size)
          }
      }
    }
</script>

<style scoped>
    .work{
        background: #F3F3F3;
    }
    .center{
        width: 1200px;
        margin: 20px auto;
        background: white;
        padding: 40px 0px 0px 0px;
        border-radius: 10px;

    }
    .list{
        padding: 43px 59px;
        box-sizing: border-box;

    }
    .el-link{
        margin-right: 20px;
    }

</style>



// WEBPACK FOOTER //
// src/works/Works.vue